export default {
  'dashboard': {
    'monday': '星期一',
    'tuesday': '星期二',
    'wednesday': '星期三',
    'thursdday': '星期四',
    'friday': '星期五',
    'saturday': '星期六',
    'sunday': '星期日',
    'morning': '上午',
    'afternoon': '下午',
    'night': '晚上',
    'midnight': '凌晨',
    'now_time': '{nickname} {nowTimeCall}好，当前的时间为：{nowTime}',
    'now_time_show': '{year}年{month}月{day}日 {hour}:{minute}:{second} {week}',

    'admins': '管理员',
    'attachments': '附件',
    'extensions': '启用扩展',
    'groups': '管理分组',

    'system_info': '系统信息',
    'version': '当前版本',
    'domain_ip': '服务器域名/IP',
    'server_info': '服务器信息',
    'server_env': '服务器环境',
    'php_version': 'PHP 版本',
    'mysql_version': 'MySQL 版本',
    'max_upload': '最大上传限制',
    'server_time': '服务器时间'
  }

}
